import { useEffect, useState } from 'react';

import styles from './ColoredBackground.module.css';

const CSS_VAR = '--colored-background-image';

export type Props = {
  customColor?: string;
};

export function ColoredBackground({ customColor }: Props) {
  useClubBackground(customColor);
  return null;
}

function useClubBackground(customColor?: string): void {
  const [color, setColor] = useState(() => customColor ?? readClubColor());

  useEffect(() => {
    if (customColor) {
      setColor(customColor);
      return;
    }

    const el = document.documentElement;
    setColor(readClubColor());

    const observer = new MutationObserver(() => setColor(readClubColor()));
    observer.observe(el, { attributes: true, attributeFilter: ['style'] });

    return () => observer.disconnect();
  }, [customColor]);

  useEffect(() => {
    if (!color) return;

    document.body.classList.add(styles.body);
    document.body.style.setProperty(CSS_VAR, buildSvg(color));

    return () => {
      document.body.classList.remove(styles.body);
      document.body.style.removeProperty(CSS_VAR);
    };
  }, [color]);
}

function readClubColor(): string {
  return getComputedStyle(document.documentElement).getPropertyValue('--club-primary-color').trim();
}

function buildSvg(color: string): string {
  return `url("data:image/svg+xml;base64,${btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="2400" height="2000" viewBox="-1200 -1000 2400 2000"><defs><filter id="b" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur in="SourceGraphic" stdDeviation="200"/></filter></defs><ellipse cx="0" cy="0" rx="800" ry="600" fill="${color}" fill-opacity="0.4" filter="url(#b)"/></svg>`)}")`;
}
